import React from 'react';
import {Col} from 'react-bootstrap';
import cn from 'classnames';
import ArrowButton from '../common/button-arrow';

const AddStore = ({onAddStoreClicked, registration}) => (
  <Col sm={12}>
    <div className="text-center">
      <ArrowButton
        arrow={false}
        className={cn({ 'red-btn': !registration.pending })}
        onClick={onAddStoreClicked}
        submit={false}
      >
        Add another store
      </ArrowButton>
    </div>
  </Col>
);


export default AddStore;



// WEBPACK FOOTER //
// ./src/components/store-summary/add-store.jsx